export async function indexRelocationsUseCase(page, per_page, search, sort_by, relocationRepository) {
    const result = await relocationRepository.index(page, per_page, search, sort_by);
    const index = []

    result.data.data.forEach(x => {
        x = new relocationRepository.model_index(x.attributes);

        if (!x.isValid()) {
            throw new Error("Reubicación inválida");
        }
        
        x.created_at = x.created_at.split('T')[0] + ' - ' + x.created_at.split('T')[1].substring(0, 8);
        
        index.push(x);
    })

    result.data.data = index;
    return result.data
}